import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { CreateSiteScreen } from "./CreateSiteScreen";
import { EditSiteScreen } from "./EditSiteScreen";
import { SitesList } from "./SitesList";
import { ViewSiteScreen } from "./ViewSiteScreen";

export const SiteScreen = () => {
    return (
        <Routes>
            <Route index element={
               <PrivateRoute permissions={[PermissionEnum.ViewSites, PermissionEnum.CreateSite, PermissionEnum.EditSite]}>
                <SitesList />
                </PrivateRoute>
            }
            />
            <Route path="Create" element={
               <PrivateRoute permissions={[PermissionEnum.CreateSite]}>
                <CreateSiteScreen />
                </PrivateRoute>
            }
            />
            <Route path="Edit/:id" element={
               <PrivateRoute permissions={[PermissionEnum.EditSite]}>
                <EditSiteScreen />
                </PrivateRoute>
            }
            />
            <Route path="View/:id" element={
                <PrivateRoute permissions={[PermissionEnum.ViewSites]}>
                <ViewSiteScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
